import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CmsUiLogoSliderContent } from '@lobos/library';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-logo-slider',
  templateUrl: './logo-slider.component.html',
  styleUrls: ['./logo-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoSliderComponent implements OnInit {
  @Input() data!: CmsUiLogoSliderContent;

  swiperOptions: SwiperOptions | undefined;

  public ngOnInit(): void {
    this.swiperOptions = {
      speed: 400,
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20,
      pagination: {
        el: `.swiper-pagination-${this.data.id}`,
        type: 'bullets',
        dynamicBullets: false,
        clickable: true,
        bulletElement: 'button',
      },
      breakpoints: {
        769: { slidesPerView: 4, slidesPerGroup: 4 },
        1025: { slidesPerView: 7, slidesPerGroup: 7 },
      },
    };
  }
}
